import i18next from 'i18next';

i18next.addResources('es_CL', 'CustomPizza', {
  closeCustomPizza: 'Botón cerrar arma tu pizza'
});

i18next.addResources('pt_PT', 'Cart', {
  closeCustomPizza: 'Botão Fechar para criar sua pizza'
});
